import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import TitleSetter from "../../component/TitleSetter";
import StoreTitle from "../../component/StoreTitle";

const AccessHero = () => {
  const navigate = useNavigate();

  return (
    <>
      <TitleSetter title="Access" />
      <Box sx={{ padding: 3 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/dashboard")}
          sx={{ marginBottom: 3 }}
        >
          Back
        </Button>
        <Box sx={{ marginTop: -8 }}>
          <StoreTitle title="Access Management" />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 4,
            gap: 2,
          }}
        >
          {/* <Button
          variant="outlined"
          onClick={() => navigate("/access-management")}
        >
          Manage Access
        </Button> */}
        </Box>
      </Box>
    </>
  );
};

export default AccessHero;
